/**
 * Purpose:
 *   Shared breakpoint constants for responsive design.
 *   Single source of truth for desktop breakpoint used across Tailwind config and JavaScript hooks.
 *
 * Notes:
 *   - Desktop breakpoint: 768px (aligned with Tailwind's default 'md' breakpoint)
 *   - Mobile: max-width 767px
 *   - Desktop: min-width 768px
 *   - Always import this constant instead of using magic numbers
 *   - Used in: tailwind.config.ts, useDeviceType hook, and any responsive logic
 */

/**
 * Desktop breakpoint in pixels.
 * Used to determine when to switch from mobile to desktop layout.
 * 
 * @example
 * ```typescript
 * import { DESKTOP_BREAKPOINT } from '@/util/constants/breakpoints';
 * 
 * const isDesktop = window.innerWidth >= DESKTOP_BREAKPOINT;
 * ```
 */
export const DESKTOP_BREAKPOINT = 768;

